(function () {
  // Tag => message mapping (add as many as you want)
  const TAG_MESSAGES = {
      "bundle: 2 for $10 and 3 for $15": "Sticker Bundle: 2 for $10 and 3 for $15",
      "patch-bundle: 2 for $25 and 3 for $35": "Patch Bundle: 2 for $25 and 3 for $35",
      "core-essentials-bundle: 3 for $49 and 6 for $99": "Core Essential Tees Bundle: 3 for $49 and 6 for $99",
    // "2polosfour199": "Buy 2 for $199"
  };

  function normalize(tag) {
    return String(tag || "").trim().toLowerCase();
  }

  function getMessageFromTags(tags) {
    for (const t of tags) {
      const key = normalize(t);
      if (TAG_MESSAGES[key]) return TAG_MESSAGES[key];
    }
    return "";
  }

  function applyMessages(root = document) {
    const nodes = root.querySelectorAll(".tag-promo-message[data-product-tags]");
    nodes.forEach((el) => {
      const raw = el.getAttribute("data-product-tags") || "";
      const tags = raw.split(",").map(normalize).filter(Boolean);
      const msg = getMessageFromTags(tags);
      if (msg) {
        el.textContent = msg;
        el.style.display = "";
      } else {
        el.textContent = "";
        el.style.display = "none";
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => applyMessages());
  document.addEventListener("shopify:section:load", (e) => applyMessages(e.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        const promoEls = node.querySelectorAll?.(".tag-promo-message[data-product-tags]");
        if (promoEls?.length) applyMessages(node);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();
